module.exports = __webpack_public_path__ + "static/media/rightside-img.fcbb189f.png";